<script lang="ts">
  import Card from '@smui/card';
  import { createEventDispatcher } from 'svelte';
  import { getAppConfig } from '../../../../common/config/app-config';
  import { getProductDataForGTM, getStr, isMobileWidth } from '../../../../common/util';
  import ProductTileMain from '../../../common/components/productTile/ProductTileMain.svelte';
  import Text from '../../../common/components/Text.svelte';
  import viewport from '../../../common/components/useViewportAction';
  import { redirectToPdp } from '../../services/pdp-data-services';
  import PdpButton from '../PdpButton.svelte';
  import BundleBottomSection from './BundleBottomSection.svelte';

  export let index;
  export let specialOfferDataList;
  const { percentageDiscount, tasheelPriceValuesList } = window['ACC'].config.productDetails;
  console.log(specialOfferDataList, 'specialOfferDataList');
  $: cartItems = specialOfferDataList && specialOfferDataList?.specialOfferProducts?.length;

  $: targetBundlePrice = specialOfferDataList && specialOfferDataList?.targetBundlePrice;
  $: initialBundlePrice = specialOfferDataList && specialOfferDataList?.initialBundlePrice;
  $: months = specialOfferDataList && specialOfferDataList?.tasheelPriceValue?.tasheelInstallmentMonths;
  $: installmentPrice =
    specialOfferDataList && specialOfferDataList?.tasheelPriceValue?.priceValueTasheel?.formattedValue;
  $: savingAmount = specialOfferDataList && specialOfferDataList?.savings?.formattedValue;
  $: bundleTasheelPriceValue = specialOfferDataList && specialOfferDataList?.tasheelPriceValue;

  const mon = getStr('extra.pdp.month');
  const forLabel = getStr('extra.product.cashback.for');
  const monthslabel = getStr('extra.months.text');
  const orLabel = getStr('extra.pdp.gift.options.or');

  const { currency, bnplBaseetaPaymentModeEnabled } = getAppConfig();
  const dispatcher = createEventDispatcher();

  function onBundleClickTile(index) {
    window['ACC'].extragtm.click.addToCartV2(specialOfferDataList.specialOfferProducts);
    dispatcher('bundleClickedTile', index);
  }

  function redirectToProductDetail(url, data) {
    window['ACC'].extragtm.click.trackSelectItem('', '', data);
    redirectToPdp(url);
  }
  function getPrice(pricedata) {
    return pricedata?.discountPrice?.formattedValue
      ? pricedata?.discountPrice?.formattedValue
      : pricedata.price.formattedValue;
  }
</script>

<div class="promotion-bundle-container-tile">
  <div class="card-container">
    <div class="card-container-nested-1" class:hidden={!isMobileWidth()} />
    <div class="card-container-nested-2" class:hidden={!isMobileWidth()} />
    <section class="card-container-text">
      <span class="font-weight-medium font-size-sm"><Text key="extra.bundledForYouLable" /></span>
      <span class="font-weight-regular font-size-sm card-subeading" class:hidden={isMobileWidth()}
        ><Text key="extra.weCreatedBundledForYou" /></span
      >
    </section>

    <section
      class="card-container-inn"
      use:viewport
      on:enterViewport={() =>
        window['ACC'].extragtm.click.trackViewList('', '', specialOfferDataList.specialOfferProducts)}
    >
      {#each specialOfferDataList && specialOfferDataList.specialOfferProducts as data, i}
        {#if isMobileWidth()}
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <div on:click={() => redirectToProductDetail(data?.url, data)}>
            <div class="mobile-card-view">
              <Card>
                {#if data.amplienceProductBaseUrl !== null}
                  <div class="card-container-inn-imgContaniner">
                    <picture>
                      <source type="image/webp" srcset={data.amplienceProductBaseUrl + '&fmt=webp&w=150'} />
                      <source type="image/jpeg" srcset={data.amplienceProductBaseUrl + '&fmt=jpeg&w=150'} />
                      <img src={data.amplienceProductBaseUrl + '&w=150'} alt={data.name} />
                    </picture>
                  </div>
                {/if}
                <section class="card-container-inn-desc">{data.name}</section>
                <section class="card-container-inn-price">
                  <span>
                    {currency}
                    <span class="font-weight-bold">{data.price && getPrice(data)}</span></span
                  >
                </section>
              </Card>
            </div>
          </div>
        {/if}

        {#if !isMobileWidth()}
          <ProductTileMain
            {data}
            productDataForGTM={getProductDataForGTM(data, i)}
            options={{
              desktopTileWidth: 230,
              showRatingReview: false,
              showProductTags: false,
              showFavIcon: false,
            }}
          />
        {/if}
      {/each}
    </section>
    {#if specialOfferDataList && isMobileWidth()}
      <div class="promotion-bundle-container-tile-mobBottom">
        <section class="promotion-bundle-container-tile-mobBottom-first">
          <span class="font-weight-regular font-size-sm"
            >{currency}
            <span class="font-weight-bold font-size-sm">{targetBundlePrice}</span>
            <span class="font-weight-regular promotion-bundle-container-tile-mobBottom-first-oriPrice"
              >{initialBundlePrice}</span
            ></span
          >
        </section>
        <section class="promotion-bundle-container-tile-mobBottom-second">
          {#if bnplBaseetaPaymentModeEnabled}
            <span class="tasheel-price">
              {orLabel}
              {currency}
              <span class="font-weight-bold">{installmentPrice}/{mon}</span>
              {forLabel}
              {months}
              {monthslabel}</span
            >
          {/if}
        </section>
      </div>
    {/if}

    {#if isMobileWidth()}
      <div class="card-container-pdpButton">
        <PdpButton
          on:click={() => onBundleClickTile(index)}
          label={`${getStr('extra.pdp.addalltocartlable')}(${cartItems})`}
          type="primary"
          variant="solid"
          size="large"
        />
      </div>
    {/if}

    {#if !isMobileWidth()}
      <BundleBottomSection
        on:addBundleToCart={() => onBundleClickTile(index)}
        {currency}
        {targetBundlePrice}
        {initialBundlePrice}
        percentDiscount={percentageDiscount?.formattedValue}
        {installmentPrice}
        {cartItems}
        {savingAmount}
        {tasheelPriceValuesList}
        {bundleTasheelPriceValue}
      />
    {/if}
  </div>
</div>

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  :global {
    .promotion-bundle-container-tile {
      .card-container {
        .card-container-inn {
          .bundle-product-link {
            text-decoration: none;
          }
          .mdc-card {
            position: relative;
            background: $primary-white;
            flex-direction: column;
            box-shadow: none;
          }
          .tile-content-wrapper .product-tile-container {
            .tags-fav-action-section {
              display: none;
            }
            .product-image-section {
              margin-top: 0;
              align-items: center;
              justify-content: center;
              display: flex;
              .tile-image-container {
                height: 150px;
                width: 150px;
              }
            }
            .product-title-section {
              .tile-name-container .product-name {
                font-size: 12px;
                line-height: 14px;
                text-align: left;
              }
            }
            .product-price-section {
              .tile-price-container {
                .price-wrapper {
                  .price-and-extra {
                    font-size: 16px;
                    line-height: 18px;
                  }
                  .secondary-price {
                    font-size: 11px;
                    line-height: 12px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .promotion-bundle-container-tile {
    text-align: center;
    @include desktop-min-width {
      padding: 0;
      display: flex;
      gap: 20px;
    }
    .font-weight-medium {
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      @include desktop-min-width {
        font-size: 20px;
        line-height: 22px;
      }
    }

    .font-weight-regular {
      font-size: 14px;
      line-height: 16px;
      font-weight: 400;
      color: $neutral-dark-02;
    }

    &-title {
      font-size: 36px;
      line-height: 40px;
      font-weight: 700;
      margin-bottom: 50px;
      text-align: left;
    }

    &-mobTop {
      &-first {
        padding: 24px 16px 0;
      }
      &-second {
        padding: 0px 16px 16px;
        font-size: 20px;
        line-height: 22px;
      }
    }

    &-mobBottom {
      margin-top: 16px;
      text-align: center;
      &-first-oriPrice {
        font-size: 11px;
        text-decoration-line: line-through;
        line-height: 12px;
        color: $neutral-dark-03;
      }
      &-second {
        font-size: 10px;
        margin-bottom: 12px;
        .tasheel-price {
          font-size: 10px;
          line-height: 11px;
        }
      }
    }

    .card-container {
      display: flex;
      width: auto;
      max-width: calc(100vw - 32px);
      background: $primary-white;
      border: 1px solid $secondary-gray-02;
      border-radius: 8px;
      flex-direction: column;
      position: relative;

      @include desktop-min-width {
        padding: 20px;
        gap: 24px;
        background: $neutral-light-04;
        border-radius: 20px;
        width: max-content;
      }

      &-nested-1 {
        position: absolute;
        width: -webkit-fill-available;
        height: 12px;
        left: 12px;
        right: 12px;
        bottom: -12px;
        background: $neutral-light-03;
        border-bottom-right-radius: 8px;
        border-bottom-left-radius: 8px;
      }

      &-nested-2 {
        position: absolute;
        width: -webkit-fill-available;
        height: 12px;
        left: 24px;
        right: 24px;
        bottom: -24px;
        background: $neutral-light-04;
        border-bottom-right-radius: 8px;
        border-bottom-left-radius: 8px;
      }

      &-pdpButton {
        padding: 0 16px 20px;
      }

      &-text {
        padding: 16px 0 16px 16px;
        text-align: left;
        .card-subeading {
          margin-top: 2px;
        }
        @include desktop-min-width {
          padding: 0px;
          display: grid;
          white-space: nowrap;
        }
      }

      &-inn {
        display: flex;
        padding: 0 16px;
        overflow-y: hidden;
        overflow-x: scroll;
        justify-content: center;
        gap: 8px;
        @include desktop-min-width {
          padding: 0px;
        }
        :global(img) {
          height: 100%;
        }

        .mobile-card-view {
          width: 98px;
          padding: 6px;
        }

        &-tag {
          text-align: left;
          height: 20px;
          margin: 8px 0 0 8px;
          position: absolute;
        }

        &-imgContaniner {
          width: 86px;
          height: 76px;
          img {
            width: 100%;
            height: 100%;
          }
        }

        &-desc {
          margin: 4px 0 2px;
          font-size: 9px;
          line-height: 10px;
          width: 86px;
          height: 30px;
          max-width: 87px;
          overflow: hidden;
          text-overflow: ellipsis;
          color: $neutral-dark-03;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          line-clamp: 3;

          &-brandName::after {
            content: ' \2022 ';
          }
        }

        &-price {
          font-size: 12px;
          line-height: 14px;
          text-align: center;
        }
      }
    }
  }

  .hidden {
    display: none;
  }

  .card-container-inn {
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
</style>
